<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h2 class="text-primary" style="margin-bottom: 0px">
          <i class="fas fa-file-invoice" /> Notas Fiscais NF-e
        </h2>
        <small class="text-muted">Gerencie suas Notas fiscais.</small>
      </div>

      <div class="col-md-6 text-right">
        <template>
          <b-dropdown class="ml-4" variant="success" right>
            <template v-slot:button-content>
              <i class="fas fa-plus" /> Nova Nota Fiscal
            </template>
            <b-dropdown-item @click="openViewStoreNfe('venda_nfe')"
              >NF-e Venda</b-dropdown-item
            >
            <b-dropdown-item @click="openViewStoreNfe('devolucao_nfe')"
              >NF-e Devolução</b-dropdown-item
            >
            <b-dropdown-item @click="openViewStoreNfe('devolucao_nfe_compra')"
              >NF-e Devolução de compra</b-dropdown-item
            >
            <b-dropdown-item @click="openViewStoreNfe('nfe_avulsa')">
              NF-e Avulsa
            </b-dropdown-item>

            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="openViewStoreNfe('venda_nfce')"
              >NFC-e Venda</b-dropdown-item
            >
            <!-- <b-dropdown-item @click="openViewStoreNfe('devolucao_nfce')"
              >NFC-e Devolução</b-dropdown-item
            > -->
            <!-- <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item>NF-e Entrada</b-dropdown-item> -->
          </b-dropdown>
        </template>
        <b-dropdown id="dropdown-1" text="Mais" class="m-md-2" right>
          <b-dropdown-item @click="openReport()"
            ><i class="fas fa-print mr-2"></i>Imprimir Relatório
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item @click="handledownloadXmlForm()">
            <i class="fa fa-download mr-2"></i>Download XML
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item @click="disableInvoiceRange()">
            <i class="fas fa-exclamation-triangle mr-2" />Inutilizar Notas
            Fiscais
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-12">
        <ul class="nav nav-pills">
          <li class="nav-item">
            <a
              :class="['nav-link', { active: activeNfeModel == '55' }]"
              @click="setNfeModel('55')"
              href="#"
            >
              <i class="fas fa-file-invoice" /> NF-e
            </a>
          </li>
          <li class="nav-item">
            <a
              :class="['nav-link', { active: activeNfeModel == '65' }]"
              @click="setNfeModel('65')"
              href="#"
            >
              <i class="fas fa-receipt" /> NFC-e
            </a>
          </li>
        </ul>
      </div>
    </div>
    <br />

    <div class="row">
      <div class="col-12" v-if="type_ambiente_nfe">
        <div class="alert alert-info" role="alert">
          Você esta no ambiente de Homologação da NF-e
        </div>
      </div>
    </div>
    <hr />

    <div class="row">
      <div class="col-md-4">
        <text-input :alias="'Pesquisar'" v-model="searchForm.name"></text-input>
      </div>
      <div class="col-md-4 d-flex align-items-end">
        <div class="form-group">
          <button type="button" class="btn btn-sm btn-primary" @click="select">
            <i class="fas fa-search" /> Pesquisar
          </button>
        </div>
      </div>
    </div>
    <br />
    <table-paginator :data="invoices" @pagechange="select($event)">
      <b-table
        @row-clicked="redirect($event.id, $event.status)"
        small
        borderless
        hover
        :items="invoices.data"
        :fields="fields"
      >
        <template #cell(mod)="data">
          {{ data.item.mod }}/ {{ data.item.serie }}
        </template>
        <template #cell(dhEmi)="data">
          {{ data.item.dhEmi | dateTimeBr }}
        </template>
        <template #cell(vNF)="data">
          {{ data.item.vNF | decimal }}
        </template>
        <template #cell(status)="data">
          <span
            :class="['badge', 'text-white', status[data.item.status].class]"
            style="line-height: 1.2"
            >{{ status[data.item.status].text }}</span
          >
        </template>
        <template #cell(action)="data">
          <b-dropdown
            variant="light"
            dropleft
            :boundary="'window'"
            toggle-class="text-decoration-none"
            no-caret
          >
            <template v-slot:button-content>
              <i class="fas fa-ellipsis-v text-muted" />
            </template>
            <b-dropdown-item
              v-if="data.item.status != 'a'"
              @click.stop="sendInvoice(data.item.id, data.item.nNF)"
            >
              <i class="fas fa-paper-plane" />
              Autorizar NF-e
            </b-dropdown-item>
            <!-- <b-dropdown-item @click.stop="emitDevulution(data.item.id)">
              <i class="fas fa-undo-alt" />
              Emitir Devolução
            </b-dropdown-item> -->
            <b-dropdown-item @click.stop="consultInvoice(data.item.id)">
              <i class="fas fa-search" />
              Consultar NF-e
            </b-dropdown-item>
            <b-dropdown-item @click.stop="printDanfe(data.item.chNFe)">
              <i class="fas fa-print" />
              Imprimir Danfe
            </b-dropdown-item>
            <b-dropdown-item
              @click.stop="downloadXml(data.item.chNFe, data.item.id)"
            >
              <i class="fas fa-download" />
              Baixar Xml
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>

            <b-dropdown-item
              v-if="data.item.status == 'a'"
              @click.stop="correctInvoice(data.item.id)"
            >
              <i class="fas fa-envelope" />
              Carta de Correção
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item
              v-if="data.item.status == 'a'"
              @click.stop="
                cancelInvoice(data.item.id, data.item.nNF, data.item.mod)
              "
            >
              <i class="fas fa-ban text-danger" />
              Cancelar
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </table-paginator>

    <consult-nfe-sefaz-status-form
      ref="consultNfeSefazStatusForm"
      @stored="select(currentPage)"
    />
    <cancel-nfe-sefaz-form ref="cancelNfeSefazForm" @stored="select(currentPage)" />
    <correct-letter-nfe-sefaz-form
      ref="correctLetterNfeSefazForm"
      @stored="select(currentPage)"
    />
    <send-nfe-sefaz-form ref="sendNfeSefazForm" @stored="select(currentPage)" />
    <edit-nfe-form ref="editNfeForm" @stored="select(currentPage)" />
    <error-handler :error="error" />
    <download-xml-form ref="dowloadXmlForm" />
    <disable-invoice-range-form @stored="select(currentPage)" ref="DisableInvoiceRangeForm"/>
  </div>
</template>

<script>
import Filters from "./../../mixins/Filters";
import TablePaginator from "./../../components/sections/TablePaginator.vue";
import VueRouter from "./../../router";
import ConsultNfeSefazStatusForm from "./../../components/forms/Nfe/ConsultNfeSefazStatusForm.vue";
import CancelNfeSefazForm from "./../../components/forms/Nfe/CancelNfeSefazForm.vue";
import CorrectLetterNfeSefazForm from "./../../components/forms/Nfe/CorrectLetterNfeSefazForm.vue";
import SendNfeSefazForm from "./../../components/forms/Nfe/SendNfeSefazForm.vue";
import EditNfeForm from "./../../components/forms/Nfe/EditNfeForm.vue";
import DownloadXmlForm from "../../components/invoice/forms/DownloadXmlForm.vue";
import DisableInvoiceRangeForm from '../../components/invoice/forms/DisableInvoiceRangeForm.vue';

export default {
  components: {
    TablePaginator,
    ConsultNfeSefazStatusForm,
    CancelNfeSefazForm,
    CorrectLetterNfeSefazForm,
    SendNfeSefazForm,
    EditNfeForm,
    DownloadXmlForm,
    DisableInvoiceRangeForm,
  },

  data: function () {
    return {
      fields: [
        { key: "mod", label: "Mod. / Série", class: "text-center" },
        { key: "nNF", label: "Número", class: "text-center" },
        { key: "natOp", label: "Operação", class: "text-center" },
        { key: "dest_xNome", label: "Destinatário", class: "text-center" },
        { key: "dhEmi", label: "Emissão", class: "text-center" },
        { key: "vNF", label: "Valor", class: "text-center" },
        { key: "status", label: "Status", class: "text-center" },
        { key: "action", label: "" },
      ],

      invoices: {
        data: null,
      },

      searchForm: {
        name: null,
        status: ["n", "p", "r", "d", "a", "i", "c"],
        model: "55",
      },

      status: {
        n: {
          text: "Não Enviada",
          class: "badge-secondary",
          value: "0",
        },

        p: {
          text: "Processando",
          class: "badge-info",
        },

        a: {
          text: "Autorizada",
          class: "badge-success",
        },

        c: {
          text: "Cancelada",
          class: "badge-danger",
        },
        r: {
          text: "Rejeitada",
          class: "badge-warning",
        },
        i: {
          text: "Inutilizada",
          class: "badge-secondary",
        },
      },

      error: null,
    };
  },

  async mounted() {
    if (this.$store.state.app.lastRoute.name !== 'editNfe') {
      console.log('reset page')
      this.setCurrentPage(1)
    }

    await this.select(this.currentPage)

    this.$store.commit("pageHasLoaded");
  },

  computed: {
    type_ambiente_nfe() {
      return this.$store.state.company_config.ambiente_nfe == 2
    },

    activeNfeModel() {
      return this.$store.state.invoice.activeNfeModel;
    },

    currentPage() {
      return this.$store.state.invoice.currentPage;
    },
  },

  methods: {
    async select(page = 1) {
      this.setCurrentPage(page)

      this.$store.commit("showLoading");

      this.invoices = await this.$store.dispatch("invoice/getInvoices", this.getSelectParams());

      this.$store.commit("hideLoading");
    },

    getSelectParams() {
      this.searchForm.model = this.activeNfeModel
      this.searchForm.page = this.currentPage

      return this.searchForm
    },

    setNfeModel(model) {
      this.$store.commit("invoice/setActiveNfeModel", model);
      this.select(1);
    },

    setCurrentPage(page) {
      this.$store.commit("invoice/setCurrentPage", page);
    },

    sendInvoice(id = null, nNF) {
      this.$refs.sendNfeSefazForm.open(id, nNF);
    },

    consultInvoice(id = null) {
      this.$refs.consultNfeSefazStatusForm.open(id);
    },

    cancelInvoice(id = null, nNF, mod) {
      this.$refs.cancelNfeSefazForm.open(id, nNF, mod);
    },

    correctInvoice(id = null, nNF) {
      this.$refs.correctLetterNfeSefazForm.open(id, nNF);
    },

    openEditForm(id = null, status) {
      this.$refs.editNfeForm.open(id, status);
    },

    openViewStoreNfe(state) {
      VueRouter.push({
        path: "/nfe/novo/" + state,
        params: {},
      });
    },

    redirect(id, status) {
      VueRouter.push({
        path: "/nfe/editar/" + id,
        params: {},
      });
    },

    handledownloadXmlForm() {
      this.$refs.dowloadXmlForm.open();
    },

    inutilizaNfeSefaz(nfeId) {
      this.$store.commit("showLoading");

      axios
        .post("api/nfe/disable/" + nfeId)
        .then((response) => {
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          this.$store.commit("hideLoading");
          this.error = error;
        });
    },

    printDanfe(chNFe) {
      let url = process.env.BASE_URL + "nfe/danfe/" + chNFe;

      window.open(url, "_newtab");
    },

    downloadXml(chNFe, nfeId) {
      this.$store.commit("showLoading");
      axios
        .post("api/nfe/downloadXml", {
          id: nfeId,
        })
        .then((response) => {
          this.executeDownload(chNFe + ".xml", response.data);
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          this.$store.commit("hideLoading");
          this.error = error;
        });
    },

    emitDevulution(id) {
      this.$store.commit("showLoading");
      axios
        .post("api/nfe/devolution", {
          nfeId: id,
        })
        .then((response) => {
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          this.$store.commit("hideLoading");
          this.error = error;
        });
    },

    executeDownload(name, xml) {
      const url = window.URL.createObjectURL(new Blob([xml]));
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
    },

    openReport(){
      window.open("/nfe/relatorio");
    },

    disableInvoiceRange(){
      this.$refs.DisableInvoiceRangeForm.open()
    }
  },
};
</script>
